import React from 'react';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { noop } from 'lodash';
import PropTypes from 'prop-types';
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../../constants';
import useMobileDevice from '../../hooks/useMobileDevice';

function ActionMenu(props) {
  const {
    actions,
    onAction,
    setSelectedId,
    data,
    isNotification,
    setNotificationRead,
    onNotificationClick,
  } = props;

  const [anchorEl, setAnchorEl] = React.useState(null);

  const isMobileDevice = useMobileDevice();

  const open = Boolean(anchorEl);

  const handleOpenActionMenu = (event) => {
    setAnchorEl(event.currentTarget);
    if (isMobileDevice) {
      setSelectedId(data.id);
      event.stopPropagation();
    }
    if (isNotification) {
      onNotificationClick(event);
      setNotificationRead(true);
      event.stopPropagation();
    }
  };

  const handleCloseActionMenu = (event) => {
    setAnchorEl(null);
    if (isMobileDevice || isNotification) {
      event.stopPropagation();
    }
  };

  const onSelectAction = (action, event) => {
    onAction(action);

    setAnchorEl(null);
    if (isMobileDevice || isNotification) {
      event.stopPropagation();
    }
  };

  return (
    <div className="justify-content-end d-flex">
      {actions.length > 0 ? (
        <>
          <IconButton onClick={handleOpenActionMenu}>
            <MoreHorizIcon titleAccess="More" />
          </IconButton>
          <Menu anchorEl={anchorEl} open={open} onClose={handleCloseActionMenu}>
            {actions.map((option, index) => (
              <MenuItem
                key={index}
                onClick={(event) => onSelectAction(option, event)}
              >
                {isNotification ? option.label : option.action}
              </MenuItem>
            ))}
          </Menu>
        </>
      ) : null}
    </div>
  );
}

ActionMenu.propTypes = {
  actions: PropTypes.array,
  onAction: PropTypes.func,
  setSelectedId: PropTypes.func,
  data: PropTypes.object,
  isNotification: PropTypes.bool,
  setNotificationRead: PropTypes.func,
  onNotificationClick: PropTypes.func,
};

ActionMenu.defaultProps = {
  actions: EMPTY_ARRAY,
  onAction: noop,
  setSelectedId: noop,
  data: EMPTY_OBJECT,
  isNotification: false,
  setNotificationRead: noop,
  onNotificationClick: noop,
};

export default ActionMenu;
